import styled from 'styled-components';
import WebsiteImage from 'components/WebsiteImage';

export const SectionContainer = styled.div`
  background: white;

  .section-tool-page-hero--wrapper {
    background: var(--dark);
  }

  .section-tool-page-hero--container {
    max-width: var(--max-width);
    margin: 0 auto;
    padding: ${(props) => (props.noBreadCrumb ? '60px' : '200px')} 18px
      ${(props) => (props.noOverlap ? '' : '150px')};
    display: flex;
    justify-content: center;
    flex-direction: column;

    .section-tool-page-hero--title {
      text-align: center;
      color: var(--white);
      max-width: 990px;
      margin: 0 auto;
      padding: 0 28px;
    }

    .section-tool-page-hero--description {
      color: var(--white);
      text-align: center;
      max-width: 990px;
      margin: 0 auto;
      margin-top: 24px;
      padding: 0 28px;

      .section-tool-page-hero--subheading-image {
        width: 65%;

        @media (max-width: 575px) {
          width: 80%;
        }
      }
    }
  }

  &.heat {
    background-color: var(--critical-4);
    .section-tool-page-hero--title {
      &:before {
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='80' viewBox='0 0 60 80' fill='none'%3E%3Cpath d='M37.5 0C20.4511 9.82321 22.5 37.5 22.5 37.5C22.5 37.5 15 34.9999 15 23.75C6.05204 28.9386 0 38.9114 0 50C0 66.5686 13.4315 80 30 80C46.5686 80 60.0001 66.5686 60.0001 50C59.9999 25.625 37.5 20.625 37.5 0V0ZM32.6352 69.6629C26.6068 71.1659 20.5011 67.4974 18.9978 61.4687C17.4947 55.4403 21.1632 49.3343 27.192 47.8313C41.7464 44.2024 43.5705 36.0179 43.5705 36.0179C43.5705 36.0179 50.8283 65.1268 32.6352 69.6629Z' fill='white'/%3E%3C/svg%3E");
        display: block;
        position: relative;
        width: 100%;
        text-align: center;
      }
    }
  }
  &.cool {
    background-color: var(--titan-blue-4);
    .section-tool-page-hero--title {
      &:before {
        content: url("data:image/svg+xml,%3Csvg width='74' height='80' viewBox='0 0 74 80' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M68.7228 42.3399L54.1725 46.2367L48.5639 43.0013V36.9299L54.1085 33.746L68.7225 37.6618C69.0162 37.7402 69.3114 37.7789 69.6039 37.7789C71.105 37.7789 72.4787 36.7764 72.8844 35.2578C73.3705 33.4431 72.2946 31.5781 70.48 31.0925L62.4683 28.9458L69.854 24.7055C71.4819 23.7705 72.0452 21.6921 71.11 20.0636C70.1718 18.435 68.0975 17.8708 66.4689 18.808L59.068 23.0583L61.2142 15.0439C61.6998 13.2297 60.6255 11.3643 58.81 10.8787C57.0067 10.4057 55.1341 11.4697 54.6478 13.2827L50.7482 27.8337L45.169 31.0378L39.8801 27.9798V21.5633L50.5755 10.868C51.9033 9.53958 51.9033 7.38792 50.5755 6.05934C49.2475 4.73111 47.0963 4.73111 45.7672 6.05934L39.8801 11.9463V3.40011C39.8803 1.52252 38.3574 0 36.4796 0C34.6022 0 33.0795 1.52235 33.0795 3.40011V11.9042L27.2352 6.05934C25.907 4.73111 23.7553 4.73111 22.4267 6.05934C21.0985 7.38775 21.0985 9.53941 22.4267 10.868L33.0795 21.5206V28.0045L27.8307 31.0326L22.2514 27.8314L18.3546 13.2828C17.8692 11.4698 16.0054 10.4029 14.1926 10.8789C12.3782 11.3645 11.3014 13.2298 11.7875 15.044L13.9335 23.0571L6.53299 18.808C4.90149 17.8706 2.82478 18.4336 1.89117 20.0644C0.956689 21.6933 1.52021 23.7704 3.14859 24.7054L10.5336 28.9457L2.52169 31.0923C0.707138 31.578 -0.369298 33.4429 0.116678 35.2577C0.523386 36.7762 1.89669 37.7787 3.39797 37.7787C3.69035 37.7787 3.98567 37.7401 4.28029 37.6616L18.8962 33.7445L24.4345 36.9242L24.4402 43.0012L18.8299 46.2424L4.28029 42.3397C2.47852 41.8669 0.603346 42.9321 0.116678 44.7444C-0.369298 46.5584 0.707138 48.4239 2.52169 48.907L10.5042 51.0479L3.14013 55.2991C1.51451 56.2388 0.956689 58.3165 1.89687 59.9423C2.5267 61.0365 3.66928 61.6424 4.84312 61.6424C5.41942 61.6424 6.00435 61.499 6.54024 61.1854L13.9416 56.9142L11.7875 64.958C11.3014 66.7752 12.3782 68.6348 14.1926 69.1234C14.4863 69.203 14.7815 69.2406 15.074 69.2406C16.5746 69.2406 17.9479 68.2366 18.3546 66.717L22.2708 52.1057L27.8407 48.892L33.0795 51.9149V58.4818L22.4267 69.1348C21.0985 70.4628 21.0985 72.6142 22.4267 73.9431C23.0909 74.6073 23.9594 74.9364 24.8309 74.9364C25.6994 74.9364 26.571 74.6073 27.2352 73.9431L33.0795 68.0986V76.5997C33.0795 78.4808 34.6022 80 36.4796 80C38.3574 80 39.8803 78.4804 39.8803 76.5997V68.0561L45.7674 73.9431C46.4314 74.6073 47.2999 74.9364 48.1716 74.9364C49.0432 74.9364 49.9117 74.6073 50.5757 73.9431C51.9034 72.6145 51.9034 70.4632 50.5757 69.1348L39.8803 58.4393V51.9411L45.164 48.8916L50.7324 52.1054L54.6485 66.7166C55.0547 68.2362 56.428 69.2403 57.9284 69.2403C58.2199 69.2403 58.5159 69.2026 58.8104 69.123C60.6258 68.6345 61.7 66.7748 61.2145 64.9577L59.058 56.9139L66.4622 61.1851C66.9982 61.4983 67.583 61.642 68.1595 61.642C69.3333 61.642 70.4755 61.0362 71.1056 59.942C72.0456 58.3162 71.4881 56.2388 69.8623 55.2988L62.4982 51.0483L70.4806 48.9072C72.2951 48.4241 73.371 46.5584 72.8849 44.7448C72.4017 42.9321 70.5343 41.8646 68.7228 42.3399ZM41.7634 43.0013L36.5009 46.0407L31.2422 43.0012L31.2363 36.9189L36.5009 33.8816L41.7634 36.9234V43.0013Z' fill='white'/%3E%3C/svg%3E%0A");
        display: block;
        position: relative;
        width: 100%;
        text-align: center;
      }
    }
  }

  @media (max-width: 1200px) {
    .section-tool-page-hero--container {
      padding: ${(props) => (props.noBreadCrumb ? '60px' : '150px')} 18px
        ${(props) => (props.noOverlap ? '' : '150px')};
    }
  }

  @media (max-width: 767px) {
    .section-tool-page-hero--container {
      padding-bottom: ${(props) => (props.noOverlap ? '60px' : '100px')};

      .section-tool-page-hero--title {
        font-size: var(--font-size-28);
        letter-spacing: var(--letter-spacing--0-03);
      }

      .section-tool-page-hero--description {
        margin-top: 16px;
      }

      .section-tool-page-hero--main {
        margin-top: 40px;
        padding: 0 20px;
      }
    }
  }

  @media (max-width: 575px) {
    .section-tool-page-hero--container {
      padding-top: ${(props) => (props.noBreadCrumb ? '50px' : '140px')};
    }
  }
`;

export const FormContainer = styled.div`
  background: transparent;
  margin-top: ${(props) => (props.isEmbed ? '0 !important' : '-90px')};

  .section-tool-page-form--container {
    max-width: 1046px;
    margin: 0 auto;
    padding: 0 28px;

    ${(props) => (props.isEmbed ? '& > div {box-shadow: none !important;}' : '')}
  }

  @media (max-width: 767px) {
    margin-top: -50px;

    .section-tool-page-form--container {
      padding: 0 20px;
    }
  }
`;

export const DescriptionContainer = styled.div`
  max-width: 1046px;
  margin: 70px auto;
  padding: 0 28px;

  @media (max-width: 767px) {
    padding: 0 20px;
  }
`;

export const EmbedLinkModalContainer = styled.div`
  padding: 20px;
  background: white;
  border-radius: 4px;

  .tools-embed-link--title {
    font-size: var(--font-size-h4);
  }

  .tools-embed-link--description {
    font-size: var(--font-size-16);
  }

  .tools-embed-link--iframe-code {
    padding: 19px;
    border: 1px solid var(--grey-4);
    font-weight: var(--font-weight-500);
    font-size: var(--font-size-16);
    line-height: var(--line-height-150);
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
  }

  .tools-embed-link--button-group {
    display: flex;
    justify-content: flex-end;

    button,
    a {
      margin-left: 15px;
      width: 109px;
    }
  }
`;

export const GateFormContainer = styled.div`
  .section-gate-form--submit-form {
    .section-gate-form--submit-form-title {
      font-weight: var(--font-weight-900);
      font-size: var(--font-size-h4);
      line-height: var(--line-height-110);
      display: flex;
      align-items: center;
      letter-spacing: var(--letter-spacing--0-03);
      color: var(--darkest);
    }

    .gate-form--subscribe-form {
      margin-top: 20px;
      display: flex;
      flex-direction: column;

      .gate-form--subscribe-marketo-form {
        box-shadow: none !important;
        padding: 0;

        .data-layer-form {
          flex-direction: column;

          .text-field-wrapper .text-field-input {
            width: 100%;
          }

          button {
            box-shadow: none;
          }
        }
      }
    }
  }

  @media (max-width: 767px) {
    .section-gate-form--submit-form {
      button {
        padding: 11px 24px;
      }
    }
  }
`;

export const ToolSectionContainer = styled.div`
  padding: 80px 28px;
  margin: 0 auto;
  width: calc(100vw - 56px);
  max-width: 1196px;

  @media (max-width: 767px) {
    padding-left: 20px;
    padding-right: 20px;
    width: calc(100vw - 20px);
  }
`;

export const ToolSectionFormStep = styled.div`
  display: flex !important;

  @media (max-width: 952px) {
    flex-direction: column;
    min-height: 384px;
    height: auto;
  }
`;

export const ToolSectionProgressArea = styled.div`
  margin: 35px auto 0;
  padding: 0 20px;
  width: 100%;
  max-width: 350px;

  @media (max-width: 952px) {
    max-width: 100%;
  }
`;

export const EmbedLinkContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  cursor: pointer;

  span {
    font-family: var(--font-family-body);
    font-size: var(--font-size-h5);
    font-weight: 800;
    line-height: 110%;
    color: var(--grey-8);
    margin: 2px 0 0 5px;
  }
  img {
    width: 20px;
    height: 20px;
  }
`;

export const HeroSubheadingWebsiteImage = styled(WebsiteImage)`
  margin: 20px auto 40px auto;
`;
